import type { WorkspaceDeliveryFormat } from '../lib/api/reporting';

//ADD these to the .env
export const GTM_ID = 'GTM-5CQNM3QT'; //for main account
// export const GTM_ID = 'GTM-N27D7L25'; // for demo

export const PUBLIC_ASSETS_BUCKET_URL = 'https://storage.googleapis.com/bi-studio-public-assets/';

export const TIMEZONES = [
  'EST',
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Samoa',
  'UTC',
];

export const WORKSPACE_DELIVERY_FORMATS: Record<WorkspaceDeliveryFormat, string> = {
  CSV: 'CSV',
  XLSX: 'XLSX',
  PDF: 'PDF (visualizations)',
};

export const DEFAULT_IGNORED_LOOKER_URL_PARAMS = ['embed_domain', 'embed_navigation_token', 'sdk'] as const;

export const SEARCH_DEBOUNCE_TIMEOUT = 1000;
export const FILTER_DEBOUNCE_TIMEOUT = 500;
export const MIN_SEARCH_PHRASE_LENGTH = 3;

export enum LOCAL_STORAGES {
  LAST_WORKSPACE_ID = `lastWorkspaceId`,
  PERSISTOR_PREFIX = 'gs:',
}

export const MAX_FILTER_ITEMS = 250;
export const MAX_TOTAL_FILTER_CHARACTERS = 6200;
export const CHARACTER_WARNING_THRESHOLD = 0.8;
export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_ROWS_PER_PAGE = 20;
export const DEFAULT_DIALOG_Z_INDEX = 1001;
export const DEFAULT_SORT_KEY = 'workspace_created_at';

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
